import { combineEpics, ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';

import { push } from '../../../app/reducers';
import { APPLICATION_COMPLETE, APPLICATION_DENIED, FLEET_VERIFIED } from '../../../paths';
import {
  approveApplication,
  rejectInactiveApplication,
  rejectIneligibleApplication,
  rejectInvalidApplication,
  rejectLockedApplication,
  rejectUnsupportedApplication,
  verifyApplication,
} from '../../reducers/application-result';
import { RootEpic } from '../index';

const rejectApplicationEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(
      rejectInvalidApplication,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      rejectIneligibleApplication as any,
      rejectLockedApplication,
      rejectUnsupportedApplication,
      rejectInactiveApplication,
    ),
    map(() => push(APPLICATION_DENIED)),
  );

const approveApplicationEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(approveApplication.match),
    map(() => push(APPLICATION_COMPLETE)),
  );

const verifyApplicationEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(verifyApplication.match),
    map(() => push(FLEET_VERIFIED)),
  );

const applicationResultEpic: RootEpic = combineEpics(
  rejectApplicationEpic,
  approveApplicationEpic,
  verifyApplicationEpic,
);

export { applicationResultEpic };
